import { Flyout } from "@app/shared/Flyouts";
import FlyoutContextProvider, { FlyoutContext } from "@app/shared/Flyouts/FlyoutContext";
import { preventDefaultMouseEvent } from "@app/shared/utility";
import * as React from "react";
import { useHistory } from "react-router-dom";
import { ImportQueryResults, ImportStepSettings } from ".";
import { useImportSidePanel } from "../hooks";
import { ImportPageRouter } from "../services";
import { ImportSidePanelTab } from "../state";
import { JSX } from "react";

const WrappedImportStepSidePanel = (): JSX.Element => {
  const { sidePanel } = useImportSidePanel();
  const history = useHistory();
  const importPageRouter = new ImportPageRouter();
  const flyoutContext = React.useContext(FlyoutContext);
  const [flyoutHasOpened, setFlyoutHasOpened] = React.useState(sidePanel.isOpen);

  React.useEffect(() => {
    flyoutContext.setIsFlyoutVisible(sidePanel.isOpen);
  }, [sidePanel.isOpen]);

  React.useEffect(() => {
    setFlyoutHasOpened(sidePanel.isOpen || flyoutHasOpened);
  }, [sidePanel.isOpen]);

  React.useEffect(() => {
    if (!sidePanel.isOpen && flyoutHasOpened) {
      importPageRouter.closeSidePanelRoute(history);
    }
  }, [sidePanel.isOpen]);

  const sidePanelContent = () => {
    if (!sidePanel.stepDetail) { return null; }

    return (
      <div className="d-flex flex-column justify-content-between">
        <span>{sidePanel.stepDetail.groupName}</span>
        <span>{sidePanel.stepDetail.stepName}</span>
        <div className="tabs-style-2">
          <ul className="nav nav-tabs">
            {sidePanel.stepDetail.isQueryable ? tabItem(ImportSidePanelTab.Results) : null}
            {sidePanel.stepDetail.isConfigurable ? tabItem(ImportSidePanelTab.Settings) : null}
          </ul>
        </div>
        <div className="mt-3">
          {tabContent()}
        </div>
      </div>
    );
  };

  const tabContent = () => {
    if (sidePanel.tab === ImportSidePanelTab.Results) {
      return (<ImportQueryResults />);
    } else if (sidePanel.tab === ImportSidePanelTab.Settings) {
      return (<ImportStepSettings />);
    }
  };

  const getTabClass = (tab: ImportSidePanelTab) => {
    return sidePanel.tab === tab ? "nav-link active" : "nav-link";
  };

  const openTab = (tab: ImportSidePanelTab) => {
    importPageRouter.openSidePanelRoute(history, sidePanel.step, tab);
  };

  const tabItem = (tab: ImportSidePanelTab) => {
    return (
      <li className="nav-item">
        <a className={getTabClass(tab)} href="#" role="tab" onClick={(e: React.MouseEvent) => preventDefaultMouseEvent(e, () => openTab(tab))}>{getTabText(tab)}</a>
      </li>
    );
  };

  const getTabText = (tab: ImportSidePanelTab) => {
    if (tab === ImportSidePanelTab.Results) {
      return "View Data";
    } else if (tab === ImportSidePanelTab.Settings) {
      return "Settings";
    }
  };

  return (
    <Flyout
      size="40"
      content={{
        body: sidePanelContent(),
        title: "",
      }}
    />
  );
};

export const ImportStepSidePanel = (
  <FlyoutContextProvider>
    <WrappedImportStepSidePanel />
  </FlyoutContextProvider>
);
